exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plugins[data-v-6e9eeed7] {\n  padding: 52px 0 64px;\n  background-color: #fafafa;\n}\n.plugins .plugins__header[data-v-6e9eeed7] {\n  text-align: center;\n}\n.plugins .plugins__title[data-v-6e9eeed7] .text__inner {\n  font-size: 42px;\n  line-height: 1.14;\n}\n.plugins .plugins__link[data-v-6e9eeed7] {\n  border-bottom: 1px dashed #00afa1;\n}\n.plugins .plugins__desc[data-v-6e9eeed7] {\n  max-width: 920px;\n}\n.plugins .plugins__info[data-v-6e9eeed7] {\n  max-width: 640px;\n}\n.plugins .plugins__button[data-v-6e9eeed7] {\n  padding: 18px 28px;\n  height: auto;\n  font-size: 14px;\n  line-height: 1.36;\n}", ""]);

// exports
